export default __webpack_public_path__ + "static/media/VForVendetta.a71b62ee.webp";